<!--
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-09-13 10:31:03
 * @LastEditors: luoyang
 * @LastEditTime: 2021-09-27 19:43:58
-->
<template>
  <div class="home">
    <div ref="mySwiper" class="swiper-container swiper-container-home">
      <div class="swiper-wrapper">
        <!-- 首页第一屏轮播 -->
        <div class="swiper-slide">
          <iframe src="banner/banner.html" style="width: 100%;height: 100%;" frameborder="0"></iframe>
          <topMenu class="home_top_logo"></topMenu>
        </div>
        <!-- 首页第二屏轮播 -->
        <div class="swiper-slide">
          <webWork></webWork>
        </div>
        <!-- 首页第三屏产品介绍 -->
        <div class="swiper-slide">
          <iframe src="product/index.html" style="width: 100%;height: 100%;" frameborder="0"></iframe>
        </div>
        <!-- 首页第四屏页尾 -->
        <div class="swiper-slide">
          <div ref="footer">
            <bottomFooter></bottomFooter>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import topMenu from "@/components/global/topMenu.vue";
import webWork from "./components/webWork.vue";
import bottomFooter from "@/components/global/bottomFooter.vue";
export default {
  name: "companyculture",
  components: {
    topMenu,
    webWork,
    bottomFooter,
  },
  data() {
    return {
      activeMaxPage: 4,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    /*  接受跨域通信 事件监听 */
    getPostMessage() {
      window.addEventListener("message", (event) => {
        switch (event.data) {
          case "slide-down":
            console.log("下滑");
            this.swiper.slideNext();
            break;
          case "slide-up":
            console.log("上滑");
            this.swiper.slidePrev();
            break;
        }
      });
    },
    /* 轮播最后一屏滚动方式 */
    setSwiperBottom(e) {
      this.swiper.setWrapperTransition(300);
      // 偏移量 最后一页内容不足时不再滚动全屏
      // this.$refs.footer.offsetHeight 为项目中最后一页的高度
      this.swiper.setWrapperTranslate(
        -e.height * (this.activeMaxPage - 2) - this.$refs.footer.offsetHeight
      );
    },
  },
  mounted() {
    let self = this;
    //创建一个swiper实例来实现轮播
    var swiperBox = new Swiper(".swiper-container-home", {
      pagination: ".swiper-pagination-home",
      direction: "vertical",
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 0,
      mousewheelControl: true,
      keyboardControl: true,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      onTransitionEnd: function (e) {
        if (e.activeIndex == self.activeMaxPage) {
          // 是否最后一页
          swiperBox.lockSwipeToNext();
          self.setSwiperBottom(e);
        } else {
          swiperBox.unlockSwipeToNext();
        }
      },
      onReachEnd: function (e) {
        self.setSwiperBottom(e);
      },
    });
    this.getPostMessage();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../node_modules/swiper/dist/css/swiper.min.css";
$base-color: #000;
.container {
  width: 100vw;
}
.swiper-container {
  width: 100vw;
  height: 100vh;
  .home_top_logo {
    position: fixed;
    width: 100vw;
    z-index: 1000;
    right: 0;
    top: 0;
  }
}
</style>